var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgProductBadgeLearnMode = function SvgProductBadgeLearnMode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.111 4.36-.003 1.563c0 .423.367.877.817 1.01l1.196.353c.207.06.548.06.758 0l1.196-.353c.45-.133.818-.587.818-1.01V4.376M8.025 5V3M3.77.843 1.51 2.153c-.723.42-.723 1.36 0 1.78l2.258 1.31c.405.237 1.072.237 1.477 0l2.247-1.31c.72-.42.72-1.357 0-1.777L5.246.846C4.841.606 4.174.606 3.77.843Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgProductBadgeLearnMode;